import React from 'react';
import * as types from '../../types';
import PromoCode from '../PromoCode';
import CartActions from './CartActions';
import styles from './CartSummary.module.scss';
import CartValueProps from './CartValueProps';
import { showNanoVariant } from '../NanoBanner/NanoBanner';
import { getFiGrowthBook } from '../../lib/growthbook';
import classNames from 'classnames';
import { showRescuePdpRedesign } from '../../views/RescueLanding/RescueBanner';

interface CartSummaryProps {
  allowPromoCodes?: boolean;
  allowLogin?: boolean;
  onCheckOut: (checkoutCart: types.Cart, cartPricing: types.CartPricing) => void;
}

export default function CartSummary({ allowPromoCodes = true, allowLogin = true, onCheckOut }: CartSummaryProps) {
  const cartV2Enabled = showNanoVariant() || getFiGrowthBook().getFeatureValue('nano-ecom-test-1', false);

  return (
    <>
      <div className={classNames(styles.cartSummary, { [styles.rescueCartSummary]: showRescuePdpRedesign() })}>
        {allowPromoCodes && (
          <div className={styles.cartPromoCode}>
            <PromoCode />
          </div>
        )}
        {!cartV2Enabled && <CartValueProps />}
        <CartActions onCheckOut={onCheckOut} showDigitalWallets={true} allowLogin={allowLogin} />
      </div>
    </>
  );
}
